import { PaginatedParams, PaginatedResultV2 } from "services/@types";
import apiInputService from "services/apiInputService";
import { useQuery } from "@tanstack/react-query";
import { useSubscription } from "store/auth/auth-store";
import { SupplierProfile } from "./@types";

const fetchGetSuppliers = async (
  params: PaginatedParams
): Promise<PaginatedResultV2<SupplierProfile>> => {
  const suppliers = await apiInputService.get(`/Supplier/paginated`, {
    params: { ...params },
  });
  const { data } = suppliers;

  return data._metadata as PaginatedResultV2<SupplierProfile>;
};

export const useGetSuppliers = (
  params?: PaginatedParams,
  options?: {
    staleTime: number;
    onSuccess: (data: PaginatedResultV2<SupplierProfile>) => void;
  }
) => {
  const { subscription } = useSubscription();

  return useQuery(
    ["supplier-paginated", subscription?.subscriptionId, params],
    () => fetchGetSuppliers(params),
    {
      ...options,
      enabled: !!subscription?.subscriptionId,
      keepPreviousData: true,
    }
  );
};
